/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Cap_Listen_TitleInputs */

const en_mcp_cap_listen_title = /** @type {(inputs: Mcp_Cap_Listen_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play it anywhere`)
};

const es_mcp_cap_listen_title = /** @type {(inputs: Mcp_Cap_Listen_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escúchalo donde quieras`)
};

/**
* | output |
* | --- |
* | "Play it anywhere" |
*
* @param {Mcp_Cap_Listen_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_cap_listen_title = /** @type {((inputs?: Mcp_Cap_Listen_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Cap_Listen_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_cap_listen_title(inputs)
	return en_mcp_cap_listen_title(inputs)
});